<template>
  <f7-page @page:init="onPageInit" @page:beforein="onPageBeforeIn" @page:beforeout="onPageBeforeOut" class="page-member-center" name="member-center" style="padding-bottom: var(--f7-safe-area-bottom)">
    <f7-navbar class="new_navbar" :title="$t('member_center_0001')" :back-link="false" :no-hariline="true"></f7-navbar>
    <div class="headbg">
      <f7-card class="card-user-info" v-if="getLoginState && userInfo.UserName" style="box-shadow: 0px 0px 0px">
        <f7-card-content>
          <div class="userinfocss" >
            <div><img src="../../static/images/yt999/home/ico/ZZicon/vip-logo.png" height="75" style="margin: 20px 0;"></div>

          </div>

          <!-- <f7-row class="referrerLevel" v-if="userInfo.ReferrerLevelID > 0" @click="$f7router.navigate('/member-center/myPosition/')">
            <img src="../../static/images/yt999/referrerLevel.png" />
            <span>{{ userInfo.ReferrerLevelName }}</span>
          </f7-row>
          <div v-else style="height: 0;">
            <f7-row class="referrerLevel" v-if="userInfo.IsReferrerLevelActive" @click="$f7router.navigate('/member-center/myPosition/')">
              <img src="../../static/images/yt999/referrerLevel.png" />
              <span>{{ $t("member_center_0056") }}</span>
            </f7-row>
            <f7-row v-else>
              <f7-row class="referrerLevel" v-if="enableMemberReferrerLevelUpgrade" @click="$f7router.navigate('/member-center/jobApplication/')">
                <img src="../../static/images/yt999/referrerLevel.png" />
                <span>{{ $t("jobApplication_001") }}</span>
              </f7-row>
            </f7-row>
          </div> -->

          <div class="panel-login-info">
            <f7-row no-gap>
              <f7-col width="50" class="text-left welcome" style="margin-top: 14px;border-bottom: 1px solid #56a6c0;">
                <i class="f7-icons" style="color: #fff;margin-right: 0px;">person</i>
                {{ userInfo.UserName.split(".")[1] }}
              </f7-col>
              <f7-col width="50" class="text-right welcome" style="margin-top: 14px;" v-if="enableMemberReferrerLevelUpgrade && userInfo.ReferrerLevelID > 0">
                <img src="../../static/images/yt999/referrerLevel.png" style="position: relative;top: 3px;width: 16px;"/>
                {{ userInfo.ReferrerLevelName }}
              </f7-col>
            </f7-row>
            <f7-row no-gap >
              <f7-col width="100" class="text-left welcome">{{ $t("member_center_0002", [userInfo.VipLevelName]) }}</f7-col>
            </f7-row>
            <f7-row no-gap class="login-info">
              <f7-col width="50" class="text-left title">{{ $t("member_center_0055") }}</f7-col>
              <!-- <f7-col width="65"  class="text-right detail">{{ getLoginInfo.LastLoginTs | time2 }}</f7-col> -->

              <f7-col width="65" v-if="userInfo.IsVIPActive" class="text-right detail">{{ userInfo.LatestVIPActiveTS | time2 }}</f7-col>
              <f7-col width="65" v-else class="text-right detail">{{ userInfo.RegisterTs | time2 }}</f7-col>
            </f7-row>
            <f7-row no-gap class="login-amt" v-if="ShowCreditScoreOnMemberCenter">
              <f7-col width="55" class="text-left title">{{ $t("member_center_0047") }}</f7-col>
              <f7-col width="65" class="text-right detail">
                <f7-link v-if="userInfo.CreditScore && ShowCreditScoreRuleOnMemberCenter" popup-open=".contribution-popup" >
                  <span class="amount">{{ userInfo.CreditScore }}</span>
                  <i class="f7-icons white">chevron_right</i>
                </f7-link>
                <f7-link v-else-if="userInfo.CreditScore"  >
                  <span class="amount">{{ userInfo.CreditScore }}</span>
                </f7-link>
                <preloader :list="4" v-else></preloader>
              </f7-col>
            </f7-row>
          </div>
        </f7-card-content>
      </f7-card>

    </div>

    <div style="width: 93%;margin: 0 auto;padding: 5px;padding-bottom: 40px;">
      <div class="showinfo" v-if="baseInfo.ShowInvestmentAccountBalanceOnMemberCenter">
        <f7-link popup-open=".balanceInfo-popup" style="display: block;">
          <div class="left" style="background: #eafaff;border: 0.5px solid #D4F2F4;">
            <div>{{ $t("member_center_0046") }}<br/>{{ $t("member_center_0071") }}</div>
            <div><span class="symbol">{{ currencySymbol }}</span>{{ totalBalance | formatCurrency }}</div>
            <img src="../../static/images/yt999/vip/right1.png" class="jiaoimg" >
          </div>
        </f7-link>
        <f7-link  style="display: block;color:black">
          <div class="right" style="background: #eafaff;border: 0.5px solid #D4F2F4;">
            <div>{{ $t("member_center_0068") }}<br/>{{ $t("member_center_0071") }}</div>
            <div><span class="symbol">{{ currencySymbol }}</span>{{ investmentAccountBalance | formatCurrency}}</div>
            <!-- <img src="../../static/images/yt999/vip/right2.png" class="jiaoimg" > -->
          </div>
        </f7-link>
      </div>
      <div class="showinfo" v-else style="display: block;">
        <f7-link popup-open=".balanceInfo-popup" style="display: block;">
          <div class="left" style="background: #eafaff;border: 0.5px solid #D4F2F4;">
            <div>{{ $t("member_center_0046") }}<br/>{{ $t("member_center_0071") }}</div>
            <div><span class="symbol">{{ currencySymbol }}</span>{{ totalBalance | formatCurrency }}</div>
            <img src="../../static/images/yt999/vip/right1.png" class="jiaoimg" >
          </div>
        </f7-link>
      </div>

      <div class="showinfo">
        <f7-link  style="display: block;">
          <div class="left" >
            <div>{{ $t("member_center_0061") }}</div>
            <div><span class="symbol">{{ currencySymbol }}</span>{{ memberincomestatisticsget | formatCurrency }}</div>
            <!-- <img src="../../static/images/yt999/vip/right1.png" class="jiaoimg" > -->
          </div>
        </f7-link>
        <div class="right" @click="openPopup()" >
          <div>{{ $t("member_center_0062") }}</div>
          <div><span class="symbol">{{ currencySymbol }}</span>{{ memfundsdelayedPendingamountget | formatCurrency}}</div>
          <img src="../../static/images/yt999/vip/right2.png" class="jiaoimg" >
        </div>
      </div>

      
      <div class="buttons-tab-mem-center tabs"  v-if="enableMemberReferrerLevelUpgrade">
        <f7-link tab-link="#tab-accountList" 
        @click="userInfo.IsReferrerLevelActive?
        $f7router.navigate('/member-center/myPosition/')
        :$f7.dialog.alert($t('member_center_0066'), $t('common_0004'))">
          <i class="lnk-i" style="background: url(./../static/images/yt999/zhi2.png)"></i>
          <span class="lnk-p">{{ $t("myPosition_0001") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountList" 
        @click="!userInfo.IsDefaultVIPLevel?
        $f7router.navigate('/member-center/jobApplication/')
        :$f7.dialog.alert($t('member_center_0067'), $t('common_0004'))">
          <i class="lnk-i" style="background: url(./../static/images/yt999/zhi1.png)"></i>
          <span class="lnk-p">{{ $t("jobApplication_001") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountList" href="/member-center/jobDetail/">
          <i class="lnk-i" style="background: url(./../static/images/yt999/zhi0.png)"></i>
          <span class="lnk-p">{{ $t("myPosition_0002") }}</span>
        </f7-link>
      </div>

      <div class="buttons-tab-mem-center tabs">
        <f7-link tab-link="#tab-accountList" @click="$f7router.navigate('/about/')">
          <i class="lnk-i" style="background: url(./../static/images/yt999/i_home.png)"></i>
          <span class="lnk-p">{{ $t("member_center_0064") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountList" href="/staff/">
          <i class="lnk-i" style="background: url(./../static/images/yt999/i_deposit.png)"></i>
          <span class="lnk-p">{{ $t("member_center_0065") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountList" href="/member-center/online-cs/">
          <i class="lnk-i" style="background: url(./../static/images/yt999/i_withdraw.png)"></i>
          <span class="lnk-p">{{ $t("member_center_0048") }}</span>
        </f7-link>
        <!-- <f7-link tab-link="#tab-accountList" href="/member-center/order-search/">
          <i class="lnk-i" style="background: url(./../static/images/yt999/i_deposit.png)"></i>
          <span class="lnk-p">{{ $t("app_v1_001") }}</span>
        </f7-link> -->
      </div>

      <div class="buttons-tab-mem-center tabs">
        <f7-link v-if="device" tab-link="#tab-accountCenter" href="/member-center/order-search/" >
          <i  class="lnk-i f7-icons bi-file-earmark-text-fill" ></i>
          <span class="lnk-p">{{ $t("app_v1_001") }}</span>
        </f7-link>
        <f7-link v-else tab-link="#tab-accountCenter" @click="goapp()" >
          <i class="lnk-i" style="background: url(./../static/images/yt999/i_app.png);width: 26px;height: 26px;"></i>
          <span class="lnk-p">APP</span>
        </f7-link>
        <f7-link tab-link="#tab-accountCenter" href="/member-center/deposit/" tab-link-active>
          <i class="lnk-i" style="background: url(./../static/images/yt999/i_order_center.png)"></i>
          <span class="lnk-p">{{ $t("member_center_0013") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-selfHelpPrefer" href="/member-center/withdraw/">
          <i class="lnk-i" style="background: url(./../static/images/yt999/i_order_record.png)"></i>
          <span class="lnk-p">{{ $t("member_center_0014") }}</span>
        </f7-link>
      </div>

      <div class="buttons-tab-mem-center tabs">
        <!-- <f7-link tab-link="#tab-accountCenter" href="/member-center/myPosition/" >
          <i  class="lnk-i f7-icons bi-mortarboard-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0056") }}</span>
        </f7-link> -->
        <f7-link tab-link="#tab-accountList" href="/activity/0/">
          <i  class="lnk-i f7-icons bi-bar-chart-line-fill" ></i>
          <span class="lnk-p">{{ $t("app_0005") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountCenter" href="/member-center/deposit-search/" >
          <i  class="lnk-i f7-icons bi-clipboard2-plus-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0028") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-selfHelpPrefer" href="/member-center/withdraw-search/">
          <i  class="lnk-i f7-icons bi-clipboard2-minus-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0029") }}</span>
        </f7-link>

      </div>

      <div class="buttons-tab-mem-center tabs">
        <f7-link tab-link="#tab-accountCenter" href="/member-center/member-info/tab-personal/" >
          <i  class="lnk-i f7-icons bi-person-lines-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0034") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-selfHelpPrefer" href="/member-center/bank-info/1/">
          <i  class="lnk-i f7-icons bi-credit-card-2-back-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0035") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountList" href="/member-center/change-login-pwd/">
          <i  class="lnk-i f7-icons bi-shield-lock-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0054") }}</span>
        </f7-link>
      </div>

      <div class="buttons-tab-mem-center tabs">
        <f7-link tab-link="#tab-accountList" href="/member-center/funds-search/">
          <i  class="lnk-i  f7-icons bi-clipboard2-check-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0030") }}</span>
        </f7-link>
        <!-- <f7-link tab-link="#tab-selfHelpPrefer" href="/member-center/financial-center/0/">
          <i  class="lnk-i f7-icons bi-clipboard2-pulse-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0049") }}</span>
        </f7-link> -->
        <f7-link tab-link="#tab-accountList" href="/member-center/sign-in/">
          <i class="lnk-i" style="background: url(./../static/images/yt999/check-in.png);width: 26px;height: 26px;"></i>
          <span class="lnk-p">{{$t('member_center_0020')}}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountCenter" href="/member-center/message-center/2/" style="position: relative;">
          <i  class="lnk-i f7-icons bi-envelope-heart-fill" ></i>
          <span class="lnk-p">{{ $t("member_center_0010") }}</span>
          <span class="messageNum" v-show="userMessgaeList.length > 0">{{ userMessgaeList.length }}</span>
        </f7-link>
      </div>

      <div class="buttons-tab-mem-center tabs">
        <f7-link tab-link="#tab-selfHelpPrefer" @click="openChangeLanguagePopup" :href="false">
          <i  class="lnk-i f7-icons bi-globe" ></i>
          <span class="lnk-p">{{ $t("member_center_0018") }}</span>
        </f7-link>
        <f7-link tab-link="#tab-accountList" @click="logout" :href="false">
          <i  class="lnk-i f7-icons " >square_arrow_right_fill</i>
          <span class="lnk-p">{{ $t("member_center_0019") }}</span>
        </f7-link>
        <f7-link tab-link=""  :href="false">
          <i  class="lnk-i f7-icons " ></i>
          <span class="lnk-p"></span>
        </f7-link>

      </div>

    </div>

    <f7-popup v-show="showBalanceInfoPopup" class="balanceInfo-popup" :opened="balancePopupOpened" @popup:open="initBalanceInfo" @popup:close="closedBalanceInfo">
      <f7-page>
        <f7-navbar :title="$t('member_center_0004')" class="bg2">
          <f7-nav-right>
            <f7-link popup-close>
              <i class="f7-icons" style="color: #505050">multiply_circle</i>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <f7-row no-gap class="block-balance">
            <f7-col class="text-left">{{ $t("member_center_0038") }}</f7-col>
            <f7-col class="text-right">
              <span class="symbol">{{ currencySymbol }}</span>
              {{ totalBalance | formatCurrency }}
            </f7-col>
          </f7-row>
          <!-- <f7-row no-gap class="block-balance">
            <f7-col class="text-left">{{ $t('member_center_0039') }}</f7-col>
            <f7-col class="text-right"><span class="symbol">{{ currencySymbol }}</span>{{walletBalance| formatCurrency}}</f7-col>
          </f7-row> -->
          <f7-row no-gap class="block-balance">
            <f7-col class="text-left">{{ $t("member_center_0040") }}</f7-col>
            <f7-col class="text-right">
              <span class="symbol">{{ currencySymbol }}</span>
              {{ paddingBalance | formatCurrency }}
            </f7-col>
          </f7-row>
          <f7-row no-gap class="block-balance">
            <f7-col class="text-left">{{ $t("member_center_0052") }}</f7-col>
            <f7-col class="text-right">
              <span class="symbol">{{ currencySymbol }}</span>
              {{ lockAmount | formatCurrency2 }}
            </f7-col>
          </f7-row>
          <f7-row no-gap class="block-balance">
            <f7-col class="text-left" style="width: 40%;font-size: 13px">{{ $t("member_center_0053") }}</f7-col>
            <f7-col class="text-right" style="width: 60%;font-size: 13px;" v-if="lockAmount > 0">{{ releaseTS | time2 }}</f7-col>
            <f7-col class="text-right" style="width: 60%;" v-else>- -</f7-col>
          </f7-row>
          <!-- <f7-row no-gap class="block-sign">
            <f7-col class="text-left">{{ $t('member_center_0041') }}</f7-col>
            <f7-col class="text-right"><span class="symbol">{{ currencySymbol }}</span>{{userSignAmount| formatCurrency}}</f7-col>
          </f7-row> -->
          <!-- <f7-row no-gap class="block-point">
            <f7-col class="text-left">{{ $t('member_center_0042') }}</f7-col>
            <f7-col class="text-right">{{currentBonusPoint| formatCurrency}}</f7-col>
          </f7-row> -->
        </f7-block>
      </f7-page>
    </f7-popup>

    <f7-popup v-show="showBalanceInfoPopup" class="pending-popup" :opened="balancePopupOpened"  @popup:close="closedBalanceInfo">
      <f7-page>
        <f7-navbar :title="$t('member_center_0062')">
          <f7-nav-right>
            <f7-link popup-close>
              <i class="f7-icons" style="color: #505050;">multiply_circle</i>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <pandingRecords :message="parentNum" ></pandingRecords>
      </f7-page>
    </f7-popup>

    <f7-popup  class="contribution-popup" @popup:open="getswebsiteinfoGet" >
      <f7-page>
        <f7-navbar :title="$t('member_center_0047')" class="bg2">
          <f7-nav-right>
            <f7-link popup-close>
              <i class="f7-icons" style="color: #505050">multiply_circle</i>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div style="padding: 10px;" v-if="websiteinfoGet" v-html="websiteinfoGet.CreditScoreRules"></div>
      </f7-page>
    </f7-popup>

  </f7-page>
</template>

<script>
import preloader from "../template/preloader";
import api from "../../config/api";
import common from "../../service/common";
import { setCookie, getCookie, getStore, removeStore, setStore } from "../../config/utils";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { getUserInfo, getBalancesDetail, logout, checkBonusPointWallet, userNameSignindetailDay,
   getUserNewsList, referrerinfo, getInfo, getmemberincomestatisticsget,memfundsdelayedPendingamountget,
   getwebsiteinfoGet  } from "../../axios/api";
import http from "../../axios/http";
import pandingRecords from "../template/pending-records.vue";

export default {
  components: {
    preloader,
    pandingRecords
  },
  props: {},
  data() {
    return {
      currencySymbol: "",
      totalBalance: 0,
      paddingBalance: 0,
      dowloadLink: "",
      iosDowloadLink: "",
      lastingDomain: "",
      device: getStore('device'),

      walletBalance: 0,
      investmentAccountBalance: 0,
      currentBonusPoint: 0,
      userSignAmount: 0,
      balancePopupOpened: false,
      userMessgaeList: [],
      showBalanceInfoPopup: true,
      totalProfitAmount: -1, //总收益

      lockAmount: 0, //保证金
      releaseTS: "", //保证金释放时间
      enableMemberReferrerLevelUpgrade: false,
      enableSendRedPacket: getCookie('EnableSendRedPacket'),
      memberincomestatisticsget: 0,
      memfundsdelayedPendingamountget:0,
      parentNum: 0,
      websiteinfoGet:null,

      ShowCreditScoreOnMemberCenter: false,
      ShowCreditScoreRuleOnMemberCenter: false,
      baseInfo: {},

    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userInfo", "getLoginInfo", "getLoginState"]),
  },
  methods: {
    ...mapMutations(["SETALLBALANCES"]),
    ...mapActions(["saveLoginState", "getUserInfo"]),
    getAllBalances() {
      const self = this;
      getBalancesDetail().then((data) => {
        if (data.Code === "NoError") {
          self.SETALLBALANCES(data.Data);
          self.totalBalance = data.Data.Balance;
          self.paddingBalance = data.Data.FreezeAmount;
          self.walletBalance = data.Data.Balance;
          self.investmentAccountBalance = data.Data.InvestmentAccountBalance;

          self.lockAmount = data.Data.LockAmount;
          self.releaseTS = data.Data.ReleaseTS;
        }
      });
    },
    onJob(){

    },
    
    //敬请期待
    stayTuned() {
      const self = this;
      self.$f7.toast
        .create({
          text: this.$t("home_0093"),
          position: "center",
          closeTimeout: 1000,
          cssClass: "toast-login",
          on: {
            closed: function () {
              // router.navigate("/");
            },
          },
        })
        .open();
    },
    getswebsiteinfoGet() {
      getwebsiteinfoGet().then((data) => {
        if (data.Code == "NoError") {
          this.websiteinfoGet = data.Data;
          if (!this.websiteinfoGet.CreditScoreRules || this.websiteinfoGet.CreditScoreRules == '') {
            this.websiteinfoGet.CreditScoreRules = '--';
          }
        }
      });
    },
    getMemfundsdelayedPendingamountget(){
      memfundsdelayedPendingamountget().then((data) => {
        if (data.Code === "NoError") {
          this.memfundsdelayedPendingamountget = data.Data;
          
        }
      });
    },
    gohref(href){
      if (getStore("device")) {
        window.location.href = href;
      }else{
        window.open( href, "_blank");
      }
      
    },
    goapp(){
      const isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      var href ;
      if (isApple) {
        if (!this.iosDowloadLink) {
          this.stayTuned();
          return;
        }
        href = this.iosDowloadLink;
      }else{
        if (!this.dowloadLink) {
          this.stayTuned();
          return;
        }
        href = this.dowloadLink;
      }
      window.open(href, "_blank");
    },
    openPopup(){
      this.$f7.popup.open('.pending-popup');
      this.parentNum++;
    },
    getmemberincomestatisticsget(){
      getmemberincomestatisticsget().then((data) => {
        if (data.Code === "NoError") {
          this.memberincomestatisticsget = data.Data.TotalProfitAmount;
          
        }
      });
    },
    openChangeLanguagePopup() {
      const self = this;
      self.$f7.params.dialog.closeByBackdropClick = true; //点击背景关闭
      self.$f7.dialog.open("#dialog-change-language", true);
    },
    logout() {
      const self = this;
      self.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
      self.$f7.dialog
        .create({
          title: this.$t("common_0004"),
          text: this.$t("member_center_0045"),
          cssClass: "dialog-logout",
          buttons: [
            {
              text: this.$t("common_0002"),
              cssClass: "dialog-cancel",
              close: true,
            },
            {
              text: this.$t("common_0001"),
              cssClass: "dialog-ok",
              onClick: () => {
                self.$f7.$(".dialog-backdrop").css("background", "transparent");
                logout().then((data) => {
                  common.logoutEvent(self);
                  self.saveLoginState();
                  self.$f7router.navigate("/");
                });
              },
            },
          ],
        })
        .open();
    },
    initBalanceInfo() {
      const self = this;
      self.showBalanceInfoPopup = true;
      checkBonusPointWallet().then((data) => {
        if (data.Code === "NoError") {
          self.currentBonusPoint = data.Data.CurrentBonusPoint;
        }
      });
      const param = { data: JSON.stringify({ Choose: false }) };
      userNameSignindetailDay(param).then((data) => {
        if (data.Code === "NoError") {
          self.userSignAmount = data.Data[1];
        }
      });
    },
    userMessgaeListEvent() {
      const self = this;
      const param = {
        data: JSON.stringify({
          Status: 2,
          BeginDate: 0,
          EndDate: 0,
          PageNow: 1,
          PageSize: 100,
        }),
      };
      getUserNewsList(param).then((data) => {
        if (data.Code === "NoError") {
          self.userMessgaeList = data.Data.Data;
        }
      });
    },
    tabInit(index) {
      setStore("mc-tab-active", index);
    },
    onPageInit() {
      this.saveLoginState();
      if (this.getLoginState) {
        this.getUserInfo();
        this.getAllBalances();
        this.userMessgaeListEvent();
        this.getmemberincomestatisticsget();
        this.getMemfundsdelayedPendingamountget();
        // this.getreferrerinfo();
      }
    },
    getInfo() {
      const self = this;
      getInfo().then((data) => {
        if (data.Code === "NoError" && data.Data) {
          self.baseInfo = data.Data.BaseInfo;
          self.enableMemberReferrerLevelUpgrade = data.Data.BaseInfo.EnableMemberReferrerLevelUpgrade;
          self.dowloadLink = data.Data.BaseInfo.AppDownloadSite;
          self.iosDowloadLink = data.Data.BaseInfo.AppDownloadSite_iOS;
          self.lastingDomain = data.Data.BaseInfo.LastingDomain;
          self.ShowCreditScoreOnMemberCenter = data.Data.BaseInfo.ShowCreditScoreOnMemberCenter;
          self.ShowCreditScoreRuleOnMemberCenter = data.Data.BaseInfo.ShowCreditScoreRuleOnMemberCenter;
          
          setStore("ShowTW", data.Data.BaseInfo.ShowTW);
        }
      });
    },
    //获取总佣金
    getreferrerinfo() {
      const self = this;
      referrerinfo().then((data) => {
        if (data.Code === "NoError") {
          self.referrerinfoList = data.Data;
          self.totalProfitAmount = data.Data["TotalProfitAmount"];
        }
      });
    },
    onPageBeforeIn() {
      const self = this;
      self.$nextTick(() => {
        self.$f7.emit("myCustomEvent", "member-center");
        const tabActiveIndex = getStore("mc-tab-active") || 1;
        // if (tabActiveIndex == 1) {
        //   self.$f7.tab.show("#tab-accountCenter");
        // }
        // if (tabActiveIndex == 2) {
        //   self.$f7.tab.show("#tab-selfHelpPrefer");
        // }
        // if (tabActiveIndex == 3) {
        //   self.$f7.tab.show("#tab-accountList");
        // }
        // if (tabActiveIndex == 4) {
        //   self.$f7.tab.show("#tab-personalInfo");
        // }
        // if (tabActiveIndex == 5) {
        //   self.$f7.tab.show("#tab-message");
        // }
      });
    },
    onPageBeforeOut() {
      //removeStore('mc-tab-active');
    },
    closedBalanceInfo() {
      this.balancePopupOpened = false;
      this.showBalanceInfoPopup = false;
    },
  },
  created() {
    sessionStorage.removeItem("deposit-flag");
    this.currencySymbol = getStore("currencySymbol");
    this.getInfo();
  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>

.referrerLevel {
  position: absolute;
  top: 13px;
  right: 10px;
  border-radius: 35px;
  color: white;
  border: 1px solid var(--f7-THEME-color);
  color: var(--f7-THEME-color);
  display: inline-flex;
  justify-content: center;
  padding: 5px !important;
  padding-right: 15px !important;
  img {
    width: 23px;
    margin: 0 5px;
  }
}
.user-area {
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: -18px;
  .user-name {
    // margin-right: 4px;
    position: absolute;
    top: 2px;
    left: -15px;
    font-weight: 700;
    font-size: 18px;
    // line-height: 24px;
  }

  .user-level {
    position: absolute;
    top: -5px;
    left: 60px;
    img {
      height: 18px;
      position: absolute;
      left: -77px;
      top: 32px;
    }
    span {
      color: #fff;
      position: absolute;
      top: 33px;
      font-style: italic;
      font-weight: bold;
      font-size: 12px;
      line-height: 17px;
      left: -48px;
      background: #16c6a6;
      height: 15px;
      padding-right: 15px;
      border-radius: 15px;
    }
  }
}
.gear {
  position: absolute;
  right: 10px;
  top: 15px;
  color: black;
}
.ios .page-member-center {
  background: #fafafa;
}

.list {
  font-size: 16px;
}

.img-service {
  position: absolute;
  width: 28px;
  height: 28px;
  content: url(../../static/images/yt999/home/ico/service_1.png);
}
::v-deep .list .item-title {
  color: black;
}
.f7-icons {
  font-size: 26px;
  color: var(--f7-THEME-color);
}
.ios .page-member-center .buttons-tab-mem-center{
  height: 90px;
  width: var(--f7-width-size-pt100);
  display: var(--f7-display-flex);
  justify-content: var(--f7-text-center);
  box-sizing: var(--f7-border-box);
  align-items: var(--f7-text-center);
  align-content: var(--f7-text-center);
  overflow: var(--f7-hidden);
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  margin-top: 10px;
  padding-top: 10px;
}
.messageNum{
  width: 15px;
  height: 15px;
  display: block;
  background: red;
  color: white;
  text-align: center;
  font-size: 10px;
  line-height: 16px;
  border-radius: 10px;
  position: absolute;
  right: 30%;
  top: 0;
}
.headbg{
  background: url('../../static/images/yt999/vip/headbg.png');
  background-size:100% 100%;
  .userinfocss{
    text-align: center;
    .left{
      width: 43%;
      text-align: right;
      position: relative;
      span{
        color: #9c3c00;
        font-weight: bold;
        position: absolute;
        right: 11px;
        top: 17px;
        font-size: 12px;
      }
    }
    .right{
      width: 50%;
      text-align: left;
      display: flex;
      align-items: center;
      padding-left: 6px;
      span{
        background: rgba(105, 103, 109, 0.8);
        padding: 2px 10px;
        border-radius: 20px;
        color: white;
        font-weight: bold;
        font-size: 12px;
      }
    }
  }
}

</style>
